(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["digital-download-consent"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('acf-digital-consent')) {
    customElements.define(
      'acf-digital-consent',
      class ACFDigitalConsent extends HTMLElement {
        connectedCallback() {
          this.checkbox = this.querySelector('input[type="checkbox"]');
          this.error = this.querySelector('[role="alert"]');
          this.digitalVariantIds = new Set(JSON.parse(this.dataset.digitalVariantIds || '[]'));
          this.blockedButtons = new Map();
          this.scope = this.closest('.shopify-section') || this.closest('product-component') || document;

          this.handleChange = this.handleChange.bind(this);
          this.handleSubmit = this.handleSubmit.bind(this);
          this.handleClick = this.handleClick.bind(this);
          this.scheduleUpdate = this.scheduleUpdate.bind(this);

          this.checkbox?.addEventListener('change', this.handleChange);
          document.addEventListener('change', this.handleChange, true);
          document.addEventListener('submit', this.handleSubmit, true);
          document.addEventListener('click', this.handleClick, true);
          document.addEventListener('variant:update', this.scheduleUpdate);

          this.observer = new MutationObserver(this.scheduleUpdate);
          this.observer.observe(this.scope, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-current-variant-id', 'value'],
          });

          this.update();
        }

        disconnectedCallback() {
          this.checkbox?.removeEventListener('change', this.handleChange);
          document.removeEventListener('change', this.handleChange, true);
          document.removeEventListener('submit', this.handleSubmit, true);
          document.removeEventListener('click', this.handleClick, true);
          document.removeEventListener('variant:update', this.scheduleUpdate);
          this.observer?.disconnect();
          clearTimeout(this.updateTimer);
        }

        get productForms() {
          const productId = this.dataset.productId;
          const exact = this.scope.querySelectorAll(
            `product-form-component[data-product-id="${productId}"] form[action*="/cart/add"]`
          );
          if (exact.length) return [...exact];
          return [...this.scope.querySelectorAll('form[action*="/cart/add"]')];
        }

        get selectedVariantId() {
          for (const form of this.productForms) {
            const variantId = form.querySelector('input[name="id"]')?.value;
            if (variantId) return String(variantId);
          }

          const stickyVariantId = this.scope.querySelector('sticky-add-to-cart')?.dataset.currentVariantId;
          if (stickyVariantId) return String(stickyVariantId);

          return new URL(window.location.href).searchParams.get('variant') || '';
        }

        get isDigital() {
          return this.digitalVariantIds.has(this.selectedVariantId);
        }

        get accepted() {
          return Boolean(this.checkbox?.checked);
        }

        get actionButtons() {
          return [
            ...this.scope.querySelectorAll(
              'product-form-component button[name="add"], product-form-component button[type="submit"], sticky-add-to-cart button'
            ),
          ];
        }

        scheduleUpdate() {
          clearTimeout(this.updateTimer);
          this.updateTimer = setTimeout(() => this.update(), 0);
        }

        handleChange(event) {
          if (event.target === this.checkbox) {
            this.error.hidden = true;
            this.update();
            return;
          }

          if (event.target instanceof HTMLInputElement && event.target.name === 'id') {
            this.scheduleUpdate();
          }
        }

        handleSubmit(event) {
          if (!this.productForms.includes(event.target)) return;
          if (!this.isDigital || this.accepted) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError();
        }

        handleClick(event) {
          const button = event.target.closest(
            'product-form-component button[name="add"], product-form-component button[type="submit"], sticky-add-to-cart button'
          );
          if (!button || !this.scope.contains(button)) return;
          if (!this.isDigital || this.accepted) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError();
        }

        showError() {
          this.error.hidden = false;
          this.checkbox?.focus();
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        syncPropertyInputs() {
          const shouldRecord = this.isDigital && this.accepted;
          for (const form of this.productForms) {
            let input = form.querySelector('input[data-acf-digital-consent]');
            if (!shouldRecord) {
              input?.remove();
              continue;
            }

            if (!input) {
              input = document.createElement('input');
              input.type = 'hidden';
              input.dataset.acfDigitalConsent = 'true';
              form.append(input);
            }

            input.name = `properties[${this.dataset.propertyName}]`;
            input.value = this.dataset.propertyValue;
          }
        }

        syncButtons() {
          const shouldBlock = this.isDigital && !this.accepted;
          for (const button of this.actionButtons) {
            if (shouldBlock) {
              if (!this.blockedButtons.has(button)) {
                this.blockedButtons.set(button, button.getAttribute('aria-disabled'));
              }
              button.setAttribute('aria-disabled', 'true');
              button.dataset.acfConsentBlocked = 'true';
              continue;
            }

            if (this.blockedButtons.has(button)) {
              const originalAriaDisabled = this.blockedButtons.get(button);
              if (originalAriaDisabled === null) {
                button.removeAttribute('aria-disabled');
              } else {
                button.setAttribute('aria-disabled', originalAriaDisabled);
              }
              delete button.dataset.acfConsentBlocked;
              this.blockedButtons.delete(button);
            }
          }
        }

        update() {
          const digital = this.isDigital;
          this.hidden = !digital;

          if (!digital && this.checkbox) {
            this.checkbox.checked = false;
            this.error.hidden = true;
          }

          if (this.checkbox) this.checkbox.required = digital;
          this.syncPropertyInputs();
          this.syncButtons();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
